"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var icon_1 = require("@csod/icon");
exports.Icon = icon_1.default;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["Icon"] = [];


//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/f257358f111b2299/src/.tmp/Icon/Icon.js
// module id = 791
// module chunks = 0